import { createFetchedData, LoadingState } from '@vista-digital/utilities';
export const defaultBrowsingDomainState = {
    allSiteIds: createFetchedData(LoadingState.NotLoaded),
    sitesById: {},
    selectedSiteIds: [],
    filmsById: {},
    allFilmIds: createFetchedData(LoadingState.NotLoaded),
    filmIdsBySiteId: {},
    allFilmAvailabilities: createFetchedData(LoadingState.NotLoaded),
    filmAvailabilitiesBySiteId: {},
    filmAvailabilitiesByQuery: {},
    filmAdvanceBookingRulesById: {},
    castAndCrewMembersById: {},
    genresById: {},
    censorRatingsById: {},
    showtimesById: {},
    showtimeIdsForQueryByBusinessDate: {},
    showtimeIdsByScreenId: {},
    showtimeIdsForEventBySite: {},
    attributesById: {},
    filmScreeningDatesForQuery: {},
    screensById: {},
    trailerUrlsByFilmId: {},
    eventIdsForAllEvents: createFetchedData(LoadingState.NotLoaded),
    eventsById: {}
};
//# sourceMappingURL=state.js.map